'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DateTimeHelper() {
    var dateFormat = void 0;
    var timeFormat = void 0;

    this.log = function log() {
        return (0, _moment2.default)().format('ddd, DD MMM Y HH:mm:ss');
    };

    this.getTime = function getTime(timeString) {
        var timeMoment = timeString ? (0, _moment2.default)(timeString) : (0, _moment2.default)();
        return timeFormat === '12' ? timeMoment.format('h:mmA') : timeMoment.format('HH:mm');
    };

    this.getDate = function getDate(dateString) {
        if (dateString) {
            return (0, _moment2.default)(dateString).format(dateFormat);
        }

        return (0, _moment2.default)().format(dateFormat);
    };

    this.init = function init(langCode, _timeFormat) {
        var _dateFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ddd, MMM DD Y';

        _moment2.default.locale(langCode);
        dateFormat = _dateFormat;
        timeFormat = _timeFormat;
    };
}

exports.default = new DateTimeHelper();
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/dateTimeHelper.js
// module id = 79
// module chunks = 0